import { extendTheme } from '@chakra-ui/react';

// Paleta Aididactic (misma que la plataforma: --color-primary #045a69, --color-accent #04bebe)
const teal = {
  50: '#e6f4f5',
  100: '#b2cecf',
  200: '#7fbfc6',
  300: '#4aa5b0',
  400: '#1f8494',
  500: '#045a69',
  600: '#034e5c',
  700: '#03424d',
  800: '#02363f',
  900: '#012a31',
};

const accent = {
  50: '#e6fafa',
  100: '#bff3f3',
  200: '#8fe9e9',
  300: '#5adcdc',
  400: '#2dcdcd',
  500: '#04bebe',
  600: '#039a9a',
  700: '#027777',
  800: '#025555',
  900: '#013838',
};

const theme = extendTheme({
  colors: {
    brand: {
      50: '#f9fafb',
      100: '#f3f4f6',
      200: '#e5e7eb',
      300: '#d1d5db',
      400: '#9ca3af',
      500: '#6b7280',
      600: '#4b5563',
      700: '#374151',
      800: '#1f2937',
      900: '#111827',
    },
    primary: teal,
    accent,
    // colorScheme="blue" / blue.* se usan por toda la app: apuntan a la marca
    blue: teal,
  },
  fonts: {
    heading: "'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    body: "'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  },
  styles: {
    global: {
      body: {
        bg: '#f9fafb',
        color: '#1f2937',
      },
    },
  },
  radii: {
    md: '8px',
    lg: '12px',
    xl: '16px',
  },
  shadows: {
    sm: '0 1px 3px 0 rgba(4, 90, 105, 0.1), 0 1px 2px 0 rgba(4, 90, 105, 0.06)',
    md: '0 4px 6px -1px rgba(4, 90, 105, 0.1), 0 2px 4px -1px rgba(4, 90, 105, 0.06)',
    lg: '0 10px 15px -3px rgba(4, 90, 105, 0.1), 0 4px 6px -2px rgba(4, 90, 105, 0.05)',
    '2xl': '0 25px 50px -12px rgba(4, 90, 105, 0.25)',
  },
  components: {
    Heading: {
      baseStyle: { fontWeight: 700, letterSpacing: '-0.01em' },
    },
    Button: {
      baseStyle: {
        fontWeight: 'semibold',
        borderRadius: 'md',
      },
      variants: {
        solid: {
          bg: 'primary.500',
          color: 'white',
          _hover: { bg: 'primary.600', _disabled: { bg: 'primary.500' } },
          _active: { bg: 'primary.700' },
        },
        outline: {
          borderColor: 'primary.500',
          color: 'primary.500',
          _hover: { bg: 'primary.50' },
        },
        accent: {
          bg: 'accent.500',
          color: 'white',
          _hover: { bg: 'accent.600' },
        },
      },
    },
    Progress: {
      defaultProps: { colorScheme: 'accent' },
    },
  },
});

export default theme;
